import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms'; // to use attribute ngModel in view
import { LoginModule } from './login/login.module';
import { MainComponent } from './main/main.component';
import { MainModule } from './main/main.module';
import { ProjectRouting } from './project/project.routing';
import { routing } from './app.routing';
import {CreateQuestionnaireComponent} from './project/createQuestionnaire/create-questionnaire.component';
import {JWTInterceptorService} from './HTTPInterceptors/JWTInterceptorService';
import {HTTPResponseInterceptorService} from './HTTPInterceptors/HTTPResponseInterceptorService';
import {MicrositeModule} from './microsite/microsite.module';


@NgModule({
    imports: [
        BrowserModule,
        RouterModule,
        MainModule,
        LoginModule,
        MicrositeModule,
        MainModule,
        ProjectRouting,
        routing,
        ReactiveFormsModule, HttpClientModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HTTPResponseInterceptorService, multi: true }

    ], // add NgbCarouselConfig to the component providers
    declarations: [AppComponent],
    bootstrap: [AppComponent]
})
export class AppModule { }
